import Auth from '../../modules/Authentication'
import {handleErrors, handleResponse} from '../../modules/Utils'
import {apiUrl} from '../../variables/index'

const headers = {}

export default class FuelLines {
  auth = new Auth()
  list = () => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}fuelLines/?select=${select}`, {headers})
      .then(handleErrors)
      .then(handleResponse)
  }
}
